import BaseDatePicker, { Props as BaseDatePickerProps } from './BaseDatePicker';
import { Popover, PopoverProps, popoverClasses } from '@mui/material';

export type Props = {
  open: PopoverProps['open'];
  anchorEl: PopoverProps['anchorEl'];
  anchorOrigin?: PopoverProps['anchorOrigin'];
  transformOrigin?: PopoverProps['transformOrigin'];
  onClose: PopoverProps['onClose'];
} & BaseDatePickerProps;

const DatePickerPopover = ({
  open,
  anchorEl,
  anchorOrigin,
  transformOrigin,
  onClose,
  ...baseDatePickerProps
}: Props) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin || { vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={transformOrigin || { vertical: 'top', horizontal: 'center' }}
      onClose={onClose}
      // eslint-disable-next-line no-restricted-syntax
      sx={{
        [`& .${popoverClasses.paper}`]: {
          // In future we can accept the width and height as props
          width: '340px',
          height: '380px',
          padding: '12px',
        },
      }}
    >
      <BaseDatePicker {...baseDatePickerProps} />
    </Popover>
  );
};

export default DatePickerPopover;
